export default "__VITE_ASSET__c582dd05__"